/*
  RICO URBAN — Signature-Interaktionen (docs/design/premium-interaction-concept.md)
  Keine Bibliothek. Scroll-Arbeit nur, solange eine Rolle sichtbar ist (IntersectionObserver),
  pro Frame höchstens ein Update (requestAnimationFrame).
*/
(() => {
  const root = document.documentElement;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const designMode = Boolean(window.Shopify && window.Shopify.designMode);

  const motionAllowed = () => !reduceMotion.matches && !designMode;
  const syncMotionClass = () => root.classList.toggle('rico-motion', motionAllowed());
  syncMotionClass();
  reduceMotion.addEventListener?.('change', () => {
    syncMotionClass();
    document.querySelectorAll('[data-rico-unroll]').forEach((el) => el.__ricoUpdate?.());
    document.querySelectorAll('.animate--wipe').forEach((el) => el.classList.add('is-wiped'));
  });

  /* ---------- 1. Rolle zum Abrollen ---------- */
  function initUnroll(scope) {
    scope.querySelectorAll('[data-rico-unroll]').forEach((section) => {
      if (section.__ricoUpdate) return;
      const counter = section.querySelector('[data-rico-unroll-count]');
      const total = counter ? Number(counter.dataset.total) || 0 : 0;
      let lastValue = -1;
      let lastCount = -1;
      let queued = false;

      const update = () => {
        queued = false;
        let progress = 1;
        if (root.classList.contains('rico-motion')) {
          const rect = section.getBoundingClientRect();
          const viewport = window.innerHeight;
          // 0: Section tritt unten ein · 1: Section-Ende erreicht den unteren Rand
          progress = (viewport - rect.top) / Math.max(rect.height, 1);
          progress = Math.min(1, Math.max(0, progress * 1.15));
        }
        const value = Math.round(progress * 1000) / 1000;
        if (value !== lastValue) {
          section.style.setProperty('--unroll', value);
          lastValue = value;
        }
        if (counter) {
          const count = Math.round(progress * total);
          if (count !== lastCount) {
            counter.textContent = count;
            lastCount = count;
          }
        }
      };
      const onScroll = () => {
        if (!queued) {
          queued = true;
          window.requestAnimationFrame(update);
        }
      };

      section.__ricoUpdate = update;
      update();

      if (!('IntersectionObserver' in window)) return;
      new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            window.addEventListener('scroll', onScroll, { passive: true });
            window.addEventListener('resize', onScroll, { passive: true });
            onScroll();
          } else {
            window.removeEventListener('scroll', onScroll);
            window.removeEventListener('resize', onScroll);
            update();
          }
        });
      }).observe(section);
    });
  }

  /* ---------- 2. Wisch-Enthüllung ---------- */
  let wipeObserver;
  function initWipe(scope) {
    const items = scope.querySelectorAll('.animate--wipe:not(.is-wiped)');
    if (!items.length) return;
    if (!root.classList.contains('rico-motion') || !('IntersectionObserver' in window)) {
      items.forEach((el) => el.classList.add('is-wiped'));
      return;
    }
    wipeObserver =
      wipeObserver ||
      new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-wiped');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.3 }
      );
    items.forEach((el) => wipeObserver.observe(el));
  }

  /* ---------- 4. Add-to-Cart-Rückmeldung ---------- */
  function initCartFeedback() {
    // constants.js/pubsub.js deklarieren global per const/function (nicht alle an window)
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (!event || event.source !== 'product-form') return;
      const variantId = String(event.productVariantId || '');
      document.querySelectorAll('product-form').forEach((form) => {
        const idInput = form.querySelector('[name="id"]');
        const button = form.querySelector('[name="add"]');
        if (!idInput || !button || String(idInput.value) !== variantId) return;
        button.classList.remove('rico-added');
        void button.offsetWidth;
        button.classList.add('rico-added');
        window.setTimeout(() => button.classList.remove('rico-added'), 1400);
      });
      // Der Header wird nach dem Hinzufügen neu gerendert — danach anstoßen
      window.setTimeout(() => {
        document.querySelectorAll('#cart-icon-bubble').forEach((icon) => {
          icon.classList.remove('rico-bump');
          void icon.offsetWidth;
          icon.classList.add('rico-bump');
          window.setTimeout(() => icon.classList.remove('rico-bump'), 700);
        });
      }, 120);
    });
  }

  const init = (scope = document) => {
    initUnroll(scope);
    initWipe(scope);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      init();
      initCartFeedback();
    });
  } else {
    init();
    initCartFeedback();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
